import React, { useState, useEffect } from "react";
import RaiseNewTicketModal from "./RaiseNewTicketModal";
import axios from "axios";
import { Button, Typography, Tabs, Tab, Avatar, IconButton, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ViewTicketModal from './ViewTicketModal';

import { BASE_URL } from "utils/constant";

// Icons replaced with inline SVG or emoji below. No @mui/icons-material imports.

const RaiseRequest = ({ onBack }) => {
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [requestedTickets, setRequestedTickets] = useState([]);
  const [historyTickets, setHistoryTickets] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);



  const fetchTickets = async () => {
    try {
      const orgId = JSON.parse(localStorage.getItem("organization"))?.id;
      const res = await axios.get(`${BASE_URL}/org/get/ticket/${orgId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });

      const raw = res.data;
      console.log("✅ Raw API response:", raw);

      const tickets = Array.isArray(raw.data) ? raw.data : raw.data?.tickets || [];
      console.log("✅ Extracted tickets:", tickets);

      const requested = [];

      tickets.forEach((ticket) => {
        const status = ticket.status?.toLowerCase() || "created";

        console.log('📦 Incoming ticket:', ticket);

        const formatDate = (dateStr) => {
          if (!dateStr) return '—';
          try {
            return new Date(dateStr).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: '2-digit',
            });
          } catch (e) {
            return '—';
          }
        };
        const createdAt = formatDate(ticket.created_on);



        const mappedTicket = {
          id: ticket.id,
          ticketId: ticket.ticket_number || `#TICKET-${ticket.id}`,
          title: ticket.issue_header,
          status: status,
          attachment: ticket.attachments,
          on_hold_justification: ticket.on_hold_justification,
          issue_description: ticket.issue_description,
          createdAt,
          responded_on: ticket.modified_on,
          resolution_by: null,
        };

        requested.push(mappedTicket);
      });

      console.log("✔ Final tickets pushed to UI:", requested);
      setRequestedTickets(requested);
      setHistoryTickets([]);
    } catch (err) {
      console.error("❌ Error fetching tickets", err);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);



  return (
    <div
      style={{
        position: "relative",
        height: "90vh",
        width: 430,
        background: "#fff",
        boxShadow: "-2px 0 8px rgba(0,0,0,0.07)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", height: 56, borderBottom: "1px solid #eee", padding: "0 16px" }}>
        <IconButton size="small" onClick={() => (onBack ? onBack() : navigate('/'))}>
          <span style={{ fontSize: 18, display: 'inline-block', transform: 'rotate(180deg)' }}>&#10140;</span>
        </IconButton>
        <Typography variant="subtitle1" sx={{
          flex: 1, textAlign: "center", fontWeight: 600,
          fontFamily: 'Outfit, sans-serif',
        }}>
          Customer Support Ticket
        </Typography>
        <IconButton size="small" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32 }}>
          <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 20, gap: 2 }}>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#222', display: 'block' }}></span>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#222', display: 'block' }}></span>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#222', display: 'block' }}></span>
          </span>
        </IconButton>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', height: 44, background: '#fff', padding: '0 16px', borderBottom: '1px solid #eee' }}>
        <div
          onClick={() => setTab(0)}
          style={{
            cursor: 'pointer',
            fontWeight: tab === 0 ? 500 : 300,
            fontSize: 16,
            color: tab === 0 ? '#3B0069' : '#B2B2B2',
            paddingBottom: 6,
            marginRight: 32,
            borderBottom: tab === 0 ? '4px solid #3B0069' : '4px solid transparent',
            transition: 'all 0.2s',
            width: 90,
            textAlign: 'center',
          }}
        >
          Requested
        </div>
        <div
          onClick={() => setTab(1)}
          style={{
            cursor: 'pointer',
            fontWeight: tab === 1 ? 500 : 300,
            fontSize: 16,
            color: tab === 1 ? '#3B0069' : '#B2B2B2',
            paddingBottom: 6,
            borderBottom: tab === 1 ? '4px solid #3B0069' : '4px solid transparent',
            transition: 'all 0.2s',
            width: 90,
            textAlign: 'center',
          }}
        >
          History
        </div>
      </div>

      {/* Ticket List */}
      <div style={{ flex: 1, overflowY: 'auto', padding: 12, background: '#faf9fd' }}>
        {tab === 0
          ? requestedTickets.map((ticket, idx) => (
            <div
              key={ticket.id}
              style={{
                background: '#fff',
                borderRadius: 8,
                boxShadow: '0 1px 4px rgba(108,43,215,0.07)',
                padding: 14,
                marginBottom: 14,
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                <Avatar sx={{ bgcolor: '#ece4fa', color: '#3B0069', mr: 1 }}>
                  <span role="img" aria-label="person" style={{ fontSize: 22 }}>👤</span>
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{
                    fontWeight: 600, fontSize: 15,
                    fontFamily: 'Outfit, sans-serif'
                  }}>
                    {ticket.title}
                  </Typography>
                  <Typography sx={{
                    color: '#888', fontSize: 13,
                    fontFamily: 'Outfit, sans-serif'
                  }}>
                    Ticket ID : {ticket.ticketId}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                  <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#2AD13B', marginRight: 6 }}></span>
                  <Typography sx={{
                    fontWeight: 500, color: '#2AD13B', fontSize: 14,
                    fontFamily: 'Outfit, sans-serif'
                  }}>
                    {ticket.status}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
                <Typography sx={{
                  color: '#888', fontSize: 13,
                  fontFamily: 'Outfit, sans-serif'
                }}>
                  {ticket.createdAt}
                </Typography>

                <Button
                  variant="outlined"
                  onClick={() => {
                    setSelectedTicket(ticket);
                    setViewModalOpen(true);
                  }}
                  sx={{
                    color: '#3B0069',
                    borderColor: '#3B0069',

                    borderRadius: 999,
                    fontWeight: 600,
                    fontSize: 13,
                    px: 2,
                    py: 0.5,
                    textTransform: 'none',
                    minWidth: 0,
                    '&:hover': {
                      borderColor: "#3B0069",
                      backgroundColor: '#f3e9ff',
                    }
                  }}
                >
                  View Details
                </Button>

              </Box>
            </div>
          )
          ) : (
            historyTickets.map((ticket, idx) => (
              <div
                key={ticket.id}
                style={{
                  background: '#fff',
                  borderRadius: 8,
                  boxShadow: '0 1px 4px rgba(108,43,215,0.07)',
                  padding: 14,
                  marginBottom: 14,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 8,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                  <Avatar sx={{ bgcolor: '#ece4fa', color: '#3B0069', mr: 1 }}>
                    <span role="img" aria-label="person" style={{ fontSize: 22 }}>👤</span>
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography sx={{
                      fontWeight: 600, fontSize: 15,
                      fontFamily: 'Outfit, sans-serif'
                    }}>
                      {ticket.title}
                    </Typography>
                    <Typography sx={{
                      color: '#888', fontSize: 13,
                      fontFamily: 'Outfit, sans-serif'
                    }}>
                      Ticket ID : {ticket.ticketId}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 1, gap: 0.5 }}>
                    {ticket.resolved ? (
                      <>
                        <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: '50%', background: '#ece4fa', color: '#6C2BD7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, marginRight: 4 }}>
                          <span style={{ fontWeight: 700 }}>✔</span>
                        </span>
                        <Typography sx={{
                          fontWeight: 500, color: '#3B0069', fontSize: 14,
                          fontFamily: 'Outfit, sans-serif'
                        }}>
                          Resolved
                        </Typography>
                      </>
                    ) : (
                      <>
                        <span style={{ display: 'inline-block', width: 18, height: 18, borderRadius: '50%', background: '#ece4fa', color: '#6C2BD7', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, marginRight: 4 }}>
                          <span style={{ fontWeight: 700 }}>✕</span>
                        </span>
                        <Typography sx={{
                          fontWeight: 500, color: '#3B0069', fontSize: 14,
                          fontFamily: 'Outfit, sans-serif'
                        }}>
                          Unresolved
                        </Typography>
                      </>
                    )}
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
                  <Typography sx={{
                    color: '#888', fontSize: 13,
                    fontFamily: 'Outfit, sans-serif'
                  }}>
                    {ticket.resolved ? `Resolved on ${ticket.date}` : `Requested on ${ticket.date}`}
                  </Typography>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setSelectedTicket(ticket);
                      setViewModalOpen(true);
                    }}
                    sx={{
                      color: '#3B0069',
                      borderColor: '#3B0069',
                      borderRadius: 999,
                      fontWeight: 600,
                      fontSize: 13,
                      px: 2,
                      py: 0.5,
                      textTransform: 'none',
                      minWidth: 0,
                    }}
                  >
                    View Details
                  </Button>

                </Box>
              </div>
            ))
          )}
        <Button
          onClick={() => setOpenModal(true)}
          startIcon={
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#3B0069',
                width: 24,
                height: 24,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 18,
                fontWeight: 'bold',
              }}
            >
              +
            </Box>
          }
          sx={{
            position: 'absolute',
            bottom: 24,
            right: 24, // slightly inset from right
            backgroundColor: '#3B0069',
            color: '#fff',
            fontWeight: 600,
            textTransform: 'none',
            px: 2.5,
            py: 1,
            borderRadius: 999,
            boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
            '&:hover': {
              borderColor: "#3B0069",
              backgroundColor: '#3B0069',
            }
            ,
            fontFamily: 'Outfit, sans-serif'
          }}
        >
          New request
        </Button>

      </div>
      <RaiseNewTicketModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSuccess={() => {
          setOpenModal(false);
          fetchTickets(); // ✅ Call the reusable function
        }}
      />

      <ViewTicketModal
        open={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
        ticket={selectedTicket}
      />


    </div>
  );
};

export default RaiseRequest;
